export const back = 'back';
export const forward = 'forward';

export const addEvent = (event, frame, action) => {
  frame.addEventListener(event, action);
  return () => frame.removeEventListener(event, action);
};

// graphql
export const arrayFromQuery = nodes => nodes.sort((a, b) => a.name - b.name);

export const addClass = (condition, styleClass) => condition ? ` ${styleClass}` : '';
